module.exports = __webpack_public_path__ + "img/terms.c572a3fc.jpg";